import React from 'react';
import { Box, Divider, Grid, Typography, useMediaQuery, Button, Card, ButtonBase, CardMedia, CardContent, IconButton } from "@mui/material";
import { useSelector } from "react-redux";
import WhiteInosio from "../../../icons/whiteinosio.svg";
import { selectApplicationsState } from '../sagas/pm/applicationsSlice';
import { applicantStyles } from './CustomStyles';
import { ApplicantPageStates } from '../Applicant';
import StartAppIcon from "../../../icons/StartAppIcon.svg";
import BackIcon from '../../../icons/back1.svg';
import { selectPropertyGroupDetailsState } from '../../../shared/sagas/propertyGroups/propertyGroupsSlice';

interface PropsType {
  setPageState: (pageState: ApplicantPageStates) => void,
  isCoApplicantFlow: boolean,
}

export default function ApplicantPolicies(props: PropsType) {
  const classes = applicantStyles();
  const matches560 = useMediaQuery("(max-width:560px)");
  const matches900 = useMediaQuery("(max-width:900px)");

  const { invitedApplicationResponse } = useSelector(selectApplicationsState);
  // const [company, setCompany] = React.useState<CompanyBasicConfigsDto>();
  const { propertyGroupDetails: PropertyGroupDetails } = useSelector(selectPropertyGroupDetailsState);
  
  // React.useEffect(() => {
  //   if (!!companyResponse.Uuid) setCompany(companyResponse);
  //   if (!!invitedApplicationResponse.Company) setCompany(invitedApplicationResponse.Company);
  // }, [companyResponse, invitedApplicationResponse])

  const handleGoBack = () => {
    if (!invitedApplicationResponse.Application) {
      props.setPageState(ApplicantPageStates.PropertyAddress);
    } else {
      props.setPageState(ApplicantPageStates.Landing);
    }
  }

  return (
    <Box sx={{ backgroundColor: "#F1F0F5", width: '100vw', height: "100vh", textAlign: 'center' }}>
      <Box sx={{ backgroundColor: "#ffffff", height: 93, display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: '35px' }}>
        <img src={WhiteInosio} style={{ width: "65px", height: "65px" }} alt="logo" />
        {PropertyGroupDetails?.CompanyName && !matches900 && (
          <Box sx={{ position: 'absolute', top: 0, left: 0, right: 0, height: '93px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Typography className={classes.largeText} sx={{ mb: 0, maxWidth: 340 }}>{PropertyGroupDetails?.CompanyName} Applications</Typography>
          </Box>
        )}
        {!props.isCoApplicantFlow && (        
        <Button href="/login" className={classes.signInBtn}>
          <Typography className={classes.signInText}>Sign Up | Sign In</Typography>
        </Button>)}
      </Box>

      <Box sx={{ display: 'flex', backgroundColor: '#F1F0F5', flexDirection: 'column', alignItems: 'center', mt: matches900 ? 12: 8, px: 2 }}>
        <Box className={classes.formContainer} sx={{ width: '100%', maxWidth: 715, height: 590, padding: "30px 0 40px", backgroundColor: matches560 ? "#F1F0F5": "#ffffff" }}>
          <Box sx={{ height: '100%', position: 'relative', width: '100%'}}>
            <IconButton
              edge="start"
              color="inherit"
              aria-label="go to prev"
              onClick={handleGoBack}
              sx={{
                position: 'absolute',
                left: 30,
                top: '-8px',
              }}
            >
              <img 
                src={BackIcon} 
                alt="back" 
                style={{ cursor: 'pointer' }} 
              />
            </IconButton>

            <Box display='flex' flexDirection='column' alignItems='center' sx={{ px: 2, height:'100%', width:'100%', boxSizing:'border-box' }}> {/* This box sizing property makes sure the child is kept inside the parent even with padding */} 
              <Typography className={classes.largeText} sx={{ mb: 4.5, maxWidth: 340 }}>Application Policies</Typography>

              <Box
                sx={{
                  height: '100%',
                  width:'98%',
                  overflow: 'auto',
                  px: 2,
                  "&::-webkit-scrollbar": {
                    width: 7,
                    height:7
                  },
                  "&::-webkit-scrollbar-track": {
                    boxShadow: `inset 0 0 6px rgba(0, 0, 0, 0.3)`,
                    borderRadius: '24px',
                  },
                  "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "darkgrey",
                    borderRadius: '24px',
                  },
                }}
              >
                <div style={{ fontFamily: 'Work Sans', textAlign: 'left', minHeight: matches560?260:360 }} dangerouslySetInnerHTML={{ __html: (PropertyGroupDetails?.ApplicationsSettings?.ApplicationsPolicyText ?? '') }} />
              
                <Box display='flex' justifyContent='center'>
                  <Card sx={{ 
                    padding: '0',
                    width: 340,
                    boxShadow: '0px 0px 40px rgba(0, 0, 0, 0.1)',
                    borderRadius: '20px',
                    margin: '40px 0px 20px !important',
                  }}>
                    <ButtonBase 
                      sx={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'start',
                        width: '100%',
                        padding: '20px 0px 20px 20px',
                        textAlign: 'initial',
                      }}
                      onClick={()=> {
                        if (PropertyGroupDetails?.ApplicationsSettings?.ApplicationsPetPolicyText) {
                          props.setPageState(ApplicantPageStates.PetPolicies);
                        } else {
                          props.setPageState(ApplicantPageStates.Registration);
                        }
                      }}
                    >
                      <CardMedia
                        component="img"
                        sx={{ width: 31, mx: '20px' }}
                        image={StartAppIcon}
                        alt="Start Application"
                      />
                      <CardContent>
                        <Typography sx={{
                          fontFamily: "Open Sans",
                          fontStyle: 'normal',
                          fontWeight: 600,
                          fontSize: '18px',
                          lineHeight: '25px',
                          color: '#14142B',
                        }}>
                          {!!PropertyGroupDetails?.ApplicationsSettings?.ApplicationsPetPolicyText ? 'Continue' : //There's another policy to review
                          !props.isCoApplicantFlow ? 'Start New Application' : //it's a primary applicant
                          'Add co-applicant details'//it's a co-applicant
                          }
                        </Typography>
                      </CardContent>
                    </ButtonBase>
                  </Card>
                </Box>    
              </Box>
            </Box>
          </Box>
        </Box>
        {
          matches900 ? <></> : <Grid item sx={{ width: '100%', maxWidth: 523, mt: 9 }}>
            <Divider />
            <Grid item display='flex' justifyContent='center'>
              <span className={classes.forgetText}
                onClick={() => {
                  window.open("http://support.inosio.com/");
                }}
              >
                {"Need help?"}
              </span>
            </Grid>
          </Grid>
        }
      </Box>
    </Box >
  );
}
